import React from "react";

export default function Resume() {
  return <div>Coming soon...</div>;
}
